import { __assign, __extends } from "tslib";
// DS: I13C
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var ArrowUp = /** @class */ (function (_super) {
    __extends(ArrowUp, _super);
    function ArrowUp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArrowUp.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" },
                React.createElement("path", { fillRule: "evenodd", d: "M3.404 14.96a1 1 0 101.414 1.414l7.072-7.07 7.07 7.07a1 1 0 101.415-1.414l-7.779-7.778a1 1 0 00-1.414 0L3.404 14.96z", clipRule: "evenodd" }))));
    };
    return ArrowUp;
}(React.Component));
export { ArrowUp };
export default ArrowUp;
//# sourceMappingURL=ArrowUp.js.map